<template>
  <div class="content_box" v-if="current == index">
    <div class="info_name">{{ paperName }}</div>
    <div class="subject">
      <div class="type">{{ callPaperType(paperData.questionType) }}</div>
      <div
        class="question"
        v-html="changeImgSize(JSON.parse(paperData.stem).content)"
      ></div>
    </div>
    <!-- 单选、多选 -->
    <div v-if="paperData.questionType == 1 || paperData.questionType == 2">
      <div
        v-for="(item, index) in paperItem"
        :key="index"
        class="option-box"
        :class="
          paperData.isSubmit &&
          paperData.correctAnswer.indexOf(item.title) !== -1
            ? 'correct'
            : paperData.isSubmit &&
              paperData.userAnswer.indexOf(item.title) !== -1 &&
              paperData.correctAnswer.indexOf(item.title) === -1
            ? 'error'
            : item.selected
            ? 'selected'
            : ''
        "
        @click="selected(item, index + 1)"
      >
        <!-- <el-radio v-model="radio" :label="index + 1"></el-radio> -->
        <div
          v-if="paperData.questionType == 1"
          class="radioSty"
          :class="
            paperData.isSubmit &&
            paperData.correctAnswer.indexOf(item.title) !== -1
              ? 'correctRadio'
              : paperData.isSubmit &&
                paperData.userAnswer.indexOf(item.title) !== -1 &&
                paperData.correctAnswer.indexOf(item.title) === -1
              ? 'errorRadio'
              : item.selected
              ? 'selectedRadio'
              : ''
          "
        ></div>
        <div
          v-else
          class="radioSty radioSty2"
          :class="
            paperData.isSubmit &&
            paperData.correctAnswer.indexOf(item.title) !== -1
              ? 'correctRadio'
              : paperData.isSubmit &&
                paperData.userAnswer.indexOf(item.title) !== -1 &&
                paperData.correctAnswer.indexOf(item.title) === -1
              ? 'errorRadio'
              : item.selected
              ? 'selectedRadio'
              : ''
          "
        ></div>
        <div
          v-if="paperData.questionType == 1 || paperData.questionType == 2"
          class="serial"
        >
          {{ serialNumber[index] }}
        </div>
        <div v-if="paperData.questionType == 3" class="serial">
          {{ serialNumber[index] }}
        </div>
        <div class="answer" v-html="item.content"></div>
      </div>
    </div>
    <!-- 判断题 -->
    <div v-if="paperData.questionType == 3">
      <div
        v-for="(item, index) in paperItem"
        :key="index"
        class="option-box"
        :class="
          paperData.isSubmit &&
          paperData.correctAnswer.indexOf(item.content) !== -1
            ? 'correct'
            : paperData.isSubmit &&
              paperData.correctAnswer.indexOf(paperData.userAnswer) === -1 &&
              item.content == paperData.userAnswer
            ? 'error'
            : item.selected
            ? 'selected'
            : ''
        "
        @click="selected(item, index + 1)"
      >
        <!-- <el-radio v-model="radio" :label="index + 1"></el-radio> -->
        <div
          class="radioSty"
          :class="
            paperData.isSubmit &&
            paperData.correctAnswer.indexOf(item.content) !== -1
              ? 'correctRadio'
              : paperData.isSubmit &&
                paperData.correctAnswer.indexOf(paperData.userAnswer) === -1 &&
                item.content == paperData.userAnswer
              ? 'errorRadio'
              : item.selected
              ? 'selectedRadio'
              : ''
          "
        ></div>
        <div
          v-if="paperData.questionType == 1 || paperData.questionType == 2"
          class="serial"
        >
          {{ serialNumber[index] }}
        </div>
        <div v-if="paperData.questionType == 3" class="serial">
          {{ serialNumber[index] }}
        </div>
        <div class="answer" v-html="item.content"></div>
      </div>
    </div>
    <div class="analysis_box" v-if="paperData.isSubmit">
      <div class="title">正确答案：</div>
      <!-- <div>{{ paperData.correctAnswer }}</div> -->
      <template v-if="paperData.questionType == 3">
        <span class="answer" v-html="paperData.correctAnswer"></span>
      </template>
      <template v-else>
        <span
          class="answer"
          v-show="paperData.correctAnswer.includes(item.title)"
          v-for="(item, index) in paperItem"
          :key="index"
          >{{ serialNumber[index] }}</span
        >
      </template>
    </div>
    <div
      class="analysis_box"
      v-if="
        paperData.isSubmit &&
        JSON.parse(paperData.analysis) &&
        JSON.parse(paperData.analysis).content
      "
    >
      <div class="title">答案解析：</div>
      <div
        class="question"
        v-html="changeImgSize(JSON.parse(paperData.analysis).content)"
      ></div>
    </div>

    <div class="btn_box">
      <el-button type="primary" @click="prev()" v-if="current != 0"
        >上一题</el-button
      >
      <!-- <el-button type="primary" @click="next()">{{
        current == total - 1
          ? "选好了"
          : paperData.userAnswer && !paperData.isSubmit
          ? "选好了"
          : "下一题"
      }}</el-button> -->
      <el-button type="primary" @click="next()">{{
        paperData.userAnswer && !paperData.isSubmit
          ? "选好了"
          : current == total - 1
          ? "退出答卷"
          : "下一题"
      }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    divide: {
      type: Boolean,
      default: false,
    },
    paperData: {
      type: Object,
      default: () => {},
    },
    current: {
      type: Number,
      default: 0,
    },
    paperName: {
      type: String,
      default: "",
    },
    total: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      paperItem:
        this.getPaperList(
          this.paperData
            ? this.paperData.questionOption
              ? JSON.parse(this.paperData.questionOption)
              : []
            : []
        ) || [],
      result: "",
      resultList: [],
      radio: 0,
      serialNumber: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  watch: {
    paperData(val, value) {
      if (val != value) {
        this.paperItem =
          this.getPaperList(
            this.paperData
              ? this.paperData.questionOption
                ? JSON.parse(this.paperData.questionOption)
                : []
              : []
          ) || [];
      }
    },
  },
  methods: {
    getPaperList(list) {
      if (list.length > 0) {
        list.map((item) => {
          this.$set(item, "selected", false);
        });
        return list;
      } else {
        let data = [
          {
            title: "A",
            selected: false,
            content: "正确",
          },
          {
            title: "B",
            selected: false,
            content: "错误",
          },
        ];
        return data;
      }
    },
    selected(item, index) {
      if (this.paperData.userAnswer && !this.paperData.isSubmit) {
        this.radio = 0;
      }
      if (!this.paperData.isSubmit) {
        if (
          this.paperData.questionType == 1 ||
          this.paperData.questionType == 3
        ) {
          //单选 、判断
          if (!item.selected) {
            item.selected = true;
            this.paperItem.map((items) => {
              if (items.title !== item.title) {
                items.selected = false;
              }
            });
            this.result =
              this.paperData.questionType == 3 ? item.content : item.title;
          } else {
            item.selected = false;
            this.result = "";
          }
        } else if (this.paperData.questionType == 2) {
          //多选
          if (!item.selected) {
            item.selected = true;
            this.resultList.push(item.title);
            // this.resultList = this.resultList.sort(function(s, t) {
            //   let a = s.toLowerCase();
            //   let b = t.toLowerCase();
            //   if (a < b) return -1;
            //   if (a > b) return 1;
            //   return 0;
            // });

            console.log(this.resultList, 333);

            this.result = this.resultList.toString();
          } else {
            item.selected = false;
            this.resultList.splice(this.resultList.indexOf(item.title), 1);
            this.result = this.resultList.toString();
          }
        }
        if (this.result) {
          this.radio = index;
        }

        this.$emit("selected", this.result);
      }
    },
    // 更改图片尺寸
    changeImgSize(res) {
      return (
        res.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ') || ""
      );
    },
    prev() {
      scrollTo(0, 0);
      this.$emit("prev");
    },
    next() {
      // console.log(this.paperData.userAnswer)
      // if (this.paperData.userAnswer && !this.paperData.isSubmit && this.current == this.total - 1) {
      //   this.$emit("next", true);
      // } else {
      //   this.$emit("next", false);
      // }
      if (this.paperData.userAnswer && !this.paperData.isSubmit) {
      } else {
        scrollTo(0, 0);
      }
      this.$emit("next");
      this.radio = 0;
    },
  },
};
</script>
<style scoped lang="scss">
.content_box {
  min-height: 720px;
  position: relative;
  .info_name {
    text-align: center;
    padding: 18px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    position: relative;
    line-height: 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .subject {
    padding: 30px 40px 0;
    display: flex;
    .type {
      width: 80px;
      height: 28px;
      background: #ffa83a;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      flex-shrink: 0;
    }
    .question {
      line-height: 28px;
      width: 900px;
    }
  }
  .option-box {
    display: flex;
    align-items: center;
    width: 1001px;
    background: #fbfbfb;
    border-radius: 6px;
    margin: 16px 0;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #fbfbfb;
    padding: 10px 16px;
    ::v-deep .el-radio {
      margin-right: 16px;
    }
    ::v-deep .el-radio__label {
      // display: flex;
      // align-items: center;
      display: none;
    }
    .serial {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-right: 16px;
    }
    .answer {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .option-box:hover {
    border: 1px solid #2e9adb;
  }
  .correct {
    border: 1px solid #70b603;
  }

  .error {
    border: 1px solid #d81e06;
    // color: #ffffff;
    // background-color: #2E9ADB;
    // color: #D81E06;
  }
  .selected {
    border: 1px solid #2e9adb;
  }

  .choose_option {
    border: 1px solid #2e9adb;
  }
  .btn_box {
    display: flex;
    justify-content: center;
    button {
      margin: 0 20px;
      width: 120px;
      height: 40px;
      background-color: #2e9adb;
    }
  }
  .radioSty {
    width: 11px;
    height: 11px;
    background: #ffffff;
    border: 1px solid #999999;
    border-radius: 50%;
    margin-right: 10px;
    flex-shrink: 0;
  }
  .radioSty2 {
    border-radius: 10%;
  }
  .selectedRadio {
    background: #2e9adb;
  }
  .correctRadio {
    background: #70b603;
  }
  .errorRadio {
    background: #d81e06;
  }
  .analysis_box {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    position: relative;
    display: flex;
    padding: 0 40px;
    margin-bottom: 16px;
    .title {
      flex-shrink: 0;
    }
    .title::before {
      content: "";
      width: 4px;
      height: 22px;
      background: #2e9adb;
      position: absolute;
      left: 30px;
    }
  }
}
</style>
